const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct.dataset.productHandle;
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";
var RECENT_VIEW_LIMIT = 10;

var selectors = {
  grid: "[grid-recentViewProduct]",
};

document.addEventListener("DOMContentLoaded", function () {
  var productHandle = recentViewedProductHandle || false;
  if (!productHandle)
    return console.error(
      "[recentViewPorduct] Missing `data-product-handle` attribute. Failed to update the recentViewPorduct."
    );
  updaterecentViewPorduct(productHandle);

  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    recentViewsetupGrid(Recentgrid);
  }
});

var recentViewsetupGrid = function (Recentgrid) {
  var recentViewPorduct = getrecentViewPorduct().filter(function (handle) {
    return handle && handle !== recentViewedProductHandle;
  });
  if (!recentViewPorduct.length) return;

  var requestsRecentViewed = recentViewPorduct
    .slice(-RECENT_VIEW_LIMIT)
    .reverse()
    .map(function (handle) {
      var productTileTemplateUrl =
        "/products/" + handle + "?view=recent-view-card";
      return fetch(productTileTemplateUrl)
        .then(function (res) {
          return res.status == 200 ? res.text() : "";
        })
        .catch(function () {
          return "";
        });
    });

  Promise.all(requestsRecentViewed).then(function (responses) {
    var recentViewPorductProductCards = responses.join("");
    Recentgrid.innerHTML = recentViewPorductProductCards;
    if (!Recentgrid.querySelector(".product-grid-item")) return;

    recentViewdProduct.classList.remove("no-js-inline");
    recentViewInitSlider(Recentgrid);
  });
};

// The theme starts this slider on page load, before the cards are fetched,
// so it holds no slides. Rebuild it once the cards are in the page.
var recentViewInitSlider = function (Recentgrid) {
  var sliderContainer = recentViewdProduct.querySelector(".productSlider");
  if (!sliderContainer || typeof Swiper === "undefined") return;
  if (sliderContainer.swiper) sliderContainer.swiper.destroy(true, true);

  var data = recentViewdProduct.dataset,
    mobileShow = parseInt(data.showMobile) || 2,
    extraLargeDesktopShow = parseInt(data.showExtraLarge) || 4,
    tabletShow = parseInt(data.showTablet) || extraLargeDesktopShow,
    slideCount = Recentgrid.querySelectorAll(".swiper-slide").length;

  var recentViewSlider = new Swiper(sliderContainer, {
    loop: slideCount > extraLargeDesktopShow,
    slidesPerView: mobileShow,
    spaceBetween: 20,
    centerInsufficientSlides: true,
    autoplay:
      data.autoplay == "true"
        ? { delay: parseInt(data.autoplayTime) }
        : false,
    pagination: {
      el: recentViewdProduct.querySelector(".swiper-pagination"),
      clickable: true,
      type: "fraction",
    },
    navigation: {
      nextEl: recentViewdProduct.querySelector(".swiper-button-next"),
      prevEl: recentViewdProduct.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      640: {
        slidesPerView: mobileShow,
      },
      750: {
        slidesPerView: tabletShow,
      },
      992: {
        slidesPerView: extraLargeDesktopShow,
      },
    },
  });

  if (data.autoplay == "true") {
    sliderContainer.addEventListener("mouseenter", function () {
      recentViewSlider.autoplay.stop();
    });
    sliderContainer.addEventListener("mouseleave", function () {
      recentViewSlider.autoplay.start();
    });
  }

  var setNavigationOffset = function () {
    var thumbnail = recentViewdProduct.querySelector(".card--client-height");
    if (thumbnail) {
      recentViewdProduct.style.setProperty(
        "--slider-navigation-top-offset",
        thumbnail.clientHeight / 2 + "px"
      );
    }
  };
  setNavigationOffset();
  window.addEventListener("resize", setNavigationOffset);
};

var getrecentViewPorduct = function () {
  var recentViewPorduct =
    localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || false;
  if (recentViewPorduct)
    return recentViewPorduct.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setrecentViewPorduct = function (array) {
  var recentViewPorduct = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length)
    localStorage.setItem(
      LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY,
      recentViewPorduct
    );
  return recentViewPorduct;
};

var updaterecentViewPorduct = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  var indexInrecentViewPorduct = recentViewPorduct.indexOf(handle);
  if (indexInrecentViewPorduct === -1) {
    recentViewPorduct.push(handle);
  } else {
    let currentViewdProduct = recentViewPorduct.splice(
      indexInrecentViewPorduct,
      1
    );
    recentViewPorduct.push(currentViewdProduct);
  }
  return setrecentViewPorduct(recentViewPorduct.slice(-(RECENT_VIEW_LIMIT + 1)));
};

var recentViewPorductContains = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  return recentViewPorduct.indexOf(handle) !== -1;
};

var resetrecentViewPorduct = function () {
  return setrecentViewPorduct([]);
};
